import styled from 'styled-components';
import {
  space,
  layout,
  color,
  flexbox,
  grid,
  background,
  border,
  position,
} from 'styled-system';

export const Container = styled('div')(
  space,
  layout,
  color,
  flexbox,
  grid,
  background,
  border,
  position
);